console.log(
    `
          (@@@@@@@@@@@@@@@@%           
      &@@@@@@@@@@@(      ,,            
    @@@@@@@@@@@@   %@@@@@@@@@@@@#      
  @@@@@@@@@@@@,  @@@@@@@@@@@@@@@@@@    
 @@@@@@@@@@@@/  @@@@@@@@@@@@@@@@@@@@   
,@@@@@@@@@@@@  *@@@@@@@@@@@@@@@@@@@@,  
 @@@@@@@@@@@@  /&&&&&&&&&&&&&&&&&&&&,  
 .@@@@@@@@@@@           ..             
    &@@@@@@@@           @@@@@@@@@.     
                        @@@@@@@@@@@,   
*@@@@@@@@@@@@@@@@@@@@(  @@@@@@@@@@@@.  
.@@@@@@@@@@@@@@@@@@@@(  @@@@@@@@@@@@,  
 @@@@@@@@@@@@@@@@@@@@  /@@@@@@@@@@@@   
  (@@@@@@@@@@@@@@@@&  *@@@@@@@@@@@&    
    .@@@@@@@@@@@@*  .@@@@@@@@@@@@      
                 .@@@@@@@@@@@@*        
          &@@@@@@@@@@@@@@&             
  `
);
